import React from 'react';
import PropTypes from 'prop-types';

import { SystemNotificationsContext } from './context';
import { useSystemNotificationsProvider } from './hooks';

const SystemNotificationsProvider = ({ children }) => {
  const value = useSystemNotificationsProvider();

  return (
    <SystemNotificationsContext.Provider value={value}>
      {children}
    </SystemNotificationsContext.Provider>
  );
};

SystemNotificationsProvider.propTypes = {
  children: PropTypes.node,
};

export default SystemNotificationsProvider;
